var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1),_c('notifications',{staticClass:"notification-login",attrs:{"position":"bottom right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }